import React from 'react'

import { View, ViewProps } from '../View/View'

type SectionDividerProps = ViewProps

export const SectionDivider = (props: SectionDividerProps) => {
  return <View height={16} {...props} />
}
